// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-request-forms-request-schema',
  type: 'object',
  required: [],
  properties: {
    from: {
      type: 'string',
      format: 'date-time',
    },
    until: {
      type: 'string',
      format: 'date-time',
    },
    type: {
      type: 'string',
    },
    subType: {
      type: 'string',
    },
    state: {
      type: 'boolean',
    },
    paymentType: {
      type: 'string',
    },
    paymentState: {
      type: 'string',
    },
    reminderState: {
      type: 'string',
    },
    searchCriteria: {
      type: 'string',
    },
    'paging.CurrentPage': {
      type: 'integer',
    },
    'paging.PageSize': {
      type: 'integer',
    },
    'paging.IncludeCount': {
      type: 'boolean',
    },
    'paging.NoPaging': {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
